import { replaceByObject } from '@/common/utils/strings/replace.utils';
import { isValid } from '@/common/utils/validation/common.utils';
import { LocationRequest } from '@/core/domain/locations/models/location-request.model';
import { LocationResponse } from '@/core/domain/locations/models/location-response.model';
import { Location } from '@/core/domain/locations/models/location.model';
import { SchedulesRequest } from '@/core/domain/locations/models/schedules-request';
import { SchedulesResponse } from '@/core/domain/locations/models/schedules-response';
import { LocationsRepository } from '@/core/domain/locations/repositories/locations.respository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LocationsImplRepository extends LocationsRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override findSchedules(
        locationRequest: SchedulesRequest,
    ): Observable<SchedulesResponse> {
        return this.httpClient.get<SchedulesResponse>(
            replaceByObject(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.searchSchedules,
                ].join('/'),
                {
                    id: locationRequest.id,
                },
            ),
            {
                params: locationRequest as unknown as {
                    [param: string]:
                        | string
                        | number
                        | boolean
                        | readonly (string | number | boolean)[];
                },
            },
        );
    }

    override findLocations(
        locationRequest: LocationRequest,
    ): Observable<LocationResponse> {
        if (locationRequest.searchTerm.length < 3) {
            return of({
                action: 'CONTINUE_SELECT_VEHICLES',
                type: 'SUCCESS',
                data: [],
            });
        }

        return this.httpClient
            .get(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.locations,
                ].join('/'),
                {
                    params: locationRequest as unknown as {
                        [param: string]:
                            | string
                            | number
                            | boolean
                            | readonly (string | number | boolean)[];
                    },
                },
            )
            .pipe(
                switchMap((locationsResponse) => {
                    const locations: LocationResponse = {
                        action: _.get(
                            locationsResponse,
                            'action',
                            'CONTINUE_SELECT_VEHICLES',
                        ),
                        type: _.get(locationsResponse, 'type', 'ERROR'),
                        data: [],
                    };

                    locations.data = [
                        ...this.mapGroup(
                            _.get(locationsResponse, 'data.airports', []),
                            'airport',
                            locationRequest,
                        ),
                        ...this.mapGroup(
                            _.get(locationsResponse, 'data.cities', []),
                            'city',
                            locationRequest,
                        ),
                    ];

                    return of(locations);
                }),
            );
    }
    private mapGroup(
        rawItems: any[],
        group: 'airport' | 'city',
        locationRequest: LocationRequest,
    ): Location[] {
        const mapped: Location[] = rawItems.map((item: any) => ({
            first: false,
            group,
            id: item.code,
            name: item.name,
            gps: item.gps,
            location: item.location,
            locationCode: item.details.branchCode,
            minDays: item.minDays,
            allowsReturn: item.allowsReturn,
            disabled: this.blocksReturn(locationRequest, item),
        }));

        const ordered = _.sortBy(mapped, (item) => (item.disabled ? 1 : 0));


        if (ordered.length > 0) {
            ordered[0].first = true;
        }

        return ordered;
    }

    private blocksReturn(locationRequest: LocationRequest, item: any): boolean {
        return (
            locationRequest.isReturn === true &&
            item.allowsReturn === false &&
            item.code !== locationRequest.pickupLocationId
        );
    }
}
